// @ts-nocheck
import { useParams } from 'react-router'
import { useQuery } from '@apollo/client/react'
import getGroupUrl from 'helpers/getGroupUrl'

import ItemLayout from 'js/components/Item/ItemLayout'
import { NotFound } from 'js/core/NotFound'

import getRefetchQueries from './helpers/getRefetchQueries'
import { QUESTION_ITEM } from './Item.queries'

const Item = () => {
    const params = useParams()
    const { guid, groupGuid } = params

    const { loading, data } = useQuery<any>(QUESTION_ITEM, {
        variables: {
            guid,
            groupGuid,
        },
    })

    if (loading) {
        return null
    }
    if (!data || !data.entity) {
        return <NotFound />
    }

    const { entity, viewer } = data
    const onEdit = `${getGroupUrl(params)}/questions/edit/${entity.guid}`
    const onAfterDelete = `${getGroupUrl(params)}/questions`
    const refetchQueries = getRefetchQueries(true, !!entity.group)

    return (
        <ItemLayout
            viewer={viewer}
            entity={entity}
            refetchQueries={refetchQueries}
            canUpvote
            onEdit={onEdit}
            onAfterDelete={onAfterDelete}
        />
    )
}

export default Item
